<template>
  <div class="playgrond">
    <div class='header'>
      <div></div>
    </div>
    <div class='CardContainer'>
      <div class='CardContainerGRP' >
      <div class='CardEmpty'></div>
      <div class='CardEmpty'></div>
      <div class='CardEmpty'></div>
      <div class='CardEmpty'></div>

      <div class='CardEmpty cardSubArea'><Card /></div>
      <div class='CardEmpty cardSubArea'><Card /></div>
      <div class='CardEmpty cardSubArea'><Card /></div>
      <div class='CardEmpty cardSubArea'><Card /></div>
      </div>

      <div class='CardContainerGRP' >
        <div class='CardEmpty'></div>
        <div class='CardEmpty'></div>
        <div class='CardEmpty'></div>
        <div class='CardEmpty'></div>

        <div class='CardEmpty cardSubArea'><Card /></div>
        <div class='CardEmpty cardSubArea'><Card /></div>
        <div class='CardEmpty cardSubArea'><Card /></div>
        <div class='CardEmpty cardSubArea'><Card /></div>
      </div>
    </div>
    <div class="bgleft"></div>
    <div class="bgright"></div>
    <div class="footer">
    </div>
  </div>
</template>

<script>
import Card from './Card.vue'
export default {
  name: 'PlayGround',
  components: {
     Card
  },
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header{
  position: relative;
  top:5px;
  color:#82D5E8;
  font-size:50px;
  font-style: 'Noto Sans TC';

}
.playgrond{
  position: relative;

  height: 100vh;
  background: #FFF;
  overflow: hidden;
  padding:0px 30px;
}


.CardContainer{
  position: relative;
  width: 100%;
  height: 100%;
  top:155px;
  display: flex;
  justify-content: space-between;
  z-index: 10;
  padding:0px 0px;
}

.CardContainerGRP{
  grid-template-columns: repeat(4, 100px);
  grid-template-rows: 140px 1fr;
  height: 100%;
  display: grid;
  grid-gap: 30px;
}

.cardSubArea.Card{


}

.CardEmpty{
  position: relative;
  width: 100px;
  height: 140px;
  background: #F7F6F5;
  border-color: 1px #AFAFAF;
  border-radius: 5px;
}
.animation {
width: 50px;
height: 50px;
background-color: #ed3;
-webkit-transition:  all 2s;
-o-transition:  all 2s;
transition:  all 2s;
}
.animation.movee {
-webkit-transform:  translateX(100px);
-ms-transform:  translateX(100px);
-o-transform:  translateX(100px);
transform:  translate(1280px, 300px);
}



.bgright{
    position: absolute;
    right:-100%;
    bottom: -130%;
    content:'';
    border-radius:100% 100% 100% 100%;
    background: linear-gradient( #9DBA74, #C3D8A6 60%);
    width:180%;
    height:180%;
    z-index: 1;
}

.bgleft{
    position: absolute;
    left:-95%;
    bottom: -130%;
    content:'';
    border-radius: 100% 100% 100% 100%;
    background: linear-gradient(#E4E8C0 , #CCDB8E 60%);
    width:180%;
    height:180%;
    z-index: 1;
}
.playgrond:after{

}
</style>
